<template>
  <div>
    <section id="header">
      <header>
        <router-link :to="home" class="logo">
          <img src="/img/logo.png" />
        </router-link>
        <div class="menu" @click="toggleMenu()"></div>
        <div class="title">{{ this.$store.state.title }}</div>

        <div
          v-show="this.$store.getters['reports/getUploadsLength'] > 0"
          @click="showUploads"
          class="upload"
        >
          <div class="icon"></div>
          <div class="alert">
            {{ this.$store.getters["reports/getUploadsLength"] }}
          </div>
        </div>

        <div class="user-box">
          <div class="user" @click="toggleUserMenu()">
            <div class="avatar">{{ user.letter }}</div>
            <div class="name">{{ user.name }}</div>
          </div>
          <div
            class="selectable"
            v-show="this.$store.state.usermenu_is_visible"
          >
            <div class="list">
              <!-- <router-link to="/account" class="item">Mi cuenta</router-link> -->
              <div @click="logout()" class="item">{{ $t('general.logout') }}</div>
            </div>
          </div>
        </div>
      </header>
    </section>
    <div class="separator"></div>
  </div>
</template>

<script>
import { Api } from "@/core/api.js";
const api = new Api();

export default {
  data() {
    return {
      home: "/admin",
      cart: "/cart",
      restaurant: "/",
      /*location: {
      	code: '556',
      	name: "McDonald's Tarragona Sur"
      },*/
      //   user: {
      //   	name: 'Carlos Torres',
      //   	letter: 'C',
      //   },
      title: this.market == 'ES' ? "LSM" : "LRM",
      display_locations: false,
      location_search: "",
      region: 0,
      type: 0
    };
  },
  computed: {
    market() {
      return this.$store.getters["getMarket"];
    },
    user() {
      return this.$store.getters["user/getUser"];
    },
    admin() {
      return this.$store.getters["user/isAdmin"];
    },
    location() {
      console.log(this.$store.getters["locations/getSelectedLocation"]);
      return this.$store.getters["locations/getSelectedLocation"];
    },
    locations() {
      return this.$store.getters["locations/getLocations"];
    },
    regions() {
      return this.$store.getters["locations/getRegions"];
    },
    types() {
      return this.$store.getters["locations/getTypes"];
    },
    displayed_locations() {
      var search = this.location_search.toLowerCase().trim();

      if (search != "") {
        var locations = [];
        for (var k in this.locations) {
          var l = this.locations[k];
          if (
            l.site.toLowerCase().includes(search) ||
            l.name.toLowerCase().includes(search)
          ) {
            locations.push(l);
          }
        }
        return locations;
      }
      return this.locations;
    }
  },
  methods: {
    toggleMenu() {
      if (this.$route.path != this.home) {
        this.$store.commit(
          "setMenuVisible",
          !this.$store.state.menu_is_visible
        );
        window.scrollTo(0, 0);
      }
    },
    toggleLocations() {
      if (this.$store.state.locationsmenu_is_visible) {
        this.$store.commit("setLocationsMenuVisible", false);
      } else {
        this.$store.commit("setLocationsMenuVisible", true);
      }
    },
    toggleUserMenu() {
      if (this.$store.state.usermenu_is_visible) {
        this.$store.commit("setUserMenuVisible", false);
      } else {
        this.$store.commit("setUserMenuVisible", true);
      }
    },
    select(location) {
      var self = this;
      this.$store
        .dispatch("locations/pushFavLocation", location)
        .then(function() {
          self.$store.commit("locations/setSelectedLocation", location);
          self.toggleLocations();
          self.location_search = "";
        });
    },
    logout() {
      var self = this;
      api.get("logout").then(function(data) {
        self.$store.commit("user/setAuthenticate", false);
        self.$store.commit("setOverlayVisible", false);
        self.$store.commit("setUserMenuVisible", false);
        self.$router.replace({ name: "login" });
      });
    },
    showUploads() {
      this.$store.commit("showUploads", true);
    }
  },
  created() {
    var self = this;
    /*api.post('login', {'username': 'GT500', 'password': '0ffe1abd1a08215353c233d6e009613e95eec4253832a761af28ff37ac5a150c' })
    .then(function(response){
    	console.log(response);
    	self.location.name = response;
    })*/

    /*api.get('labels')
    .then(function(response){
    	console.log(response);
    	self.location.name = response;
    })*/
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" scoped>
#header {
  width: 100%;
  height: 60px;
  position: fixed;
  left: 0;
  top: 0;
  border-bottom: 2px solid var(--main_color);
  padding: 5px 10px;
  z-index: 10;
  background: #222;

  .logo {
    height: 60px;
    cursor: pointer;
    position: absolute;
    left: 0;
    top: 0;

    img {
      height: 100%;
    }
  }

  .menu {
    float: left;
    background: url("/img/menu_w.svg") no-repeat center;
    width: 25px;
    height: 25px;
    cursor: pointer;
    margin-left: 120px;
    margin-top: 12.5px;
  }
  .title {
    float: left;
    font-size: 14pt;
    margin-left: 15px;
    margin-top: 12.5px;
    color: #fff;
  }
  .location-selector {
    float: right;
    display: inline-block;
    background: #fff;
    border-radius: 5px;
    margin-right: 25px;

    &.displayed {
      z-index: 11;
      //border: 2px solid var(--main_color);
    }
    .location {
      width: auto;
      height: 50px;
      padding: 0 10px;
      padding-right: 35px;
      border-radius: 5px;
      line-height: 50px;
      margin-right: 20px;
      background: url("/img/down.svg") no-repeat right 10px center;
      background-size: 8px;
      cursor: pointer;

      .content:before {
        content: "";
        width: 30px;
        height: 30px;
        display: inline-block;
        background: url("/img/marker.svg") no-repeat center;
        background-size: 90%;
        float: left;
        margin-top: 8px;
        margin-right: 10px;
      }

      strong {
        margin-right: 5px;
      }
    }
    .selectable {
      border-bottom: 2px solid var(--main_color);
      border-left: 2px solid var(--main_color);
      border-right: 2px solid var(--main_color);
      margin-top: 3px;

      .filter {
        padding: 5px 20px;

        .search {
          display: block;
          border: none;
          border-bottom: 1px solid #ccc;
          padding: 5px;
          outline: none;
          width: 100%;
          margin-top: 5px;
          background: url("/img/magnify.svg") no-repeat right 5px center;
          background-size: 20px;
        }
        .meta {
          overflow: hidden;
          width: 100%;
          margin-top: 5px;

          .col {
            width: 50%;
            float: left;

            select {
              width: 100%;
              padding: 5px;
              outline: none;
              border: none;
              border-bottom: 1px solid #ccc;
            }
          }
        }
      }

      .list {
        padding: 10px 5px;

        .item {
          text-align: left;
          overflow: hidden;
          padding: 10px 10px;
          cursor: pointer;

          .state {
            width: 20px;
            height: 20px;
            border-radius: 100%;
            border: 1px solid #ccc;
            float: left;
          }
          .content {
            width: calc(100% - 20px);
            padding-left: 15px;
            float: left;

            strong {
              margin-right: 5px;
            }
          }

          &.selected {
            .state {
              background: var(--main_color);
              border: none;
            }
          }
        }
      }
    }
  }

  .user-box {
    display: inline-block;
    float: right;
    border-radius: 3px;
    overflow: hidden;
    z-index: 12;

    .user {
      width: auto;
      height: 45px;
      padding: 8px 12px;
      padding-right: 35px;
      border-radius: 3px;
      background: url("/img/down.svg") no-repeat right 10px center;
      background-color: var(--main_color);
      background-size: 8px;
      cursor: pointer;

      .avatar {
        display: inline-block;
        width: 30px;
        height: 30px;
        line-height: 30px;
        text-align: center;
        border-radius: 100%;
        color: #fff;
        background: var(--dark_color);
        float: left;
      }
      .name {
        display: inline-block;
        width: calc(100% - 30px);
        padding-left: 10px;
        line-height: 30px;
        font-size: 10pt;
      }
    }
    .selectable {
      background: var(--dark_color);

      .list {
        padding: 10px 5px;

        .item {
          text-align: left;
          overflow: hidden;
          padding: 10px 10px;
          cursor: pointer;
          font-size: 10pt;
          color: #fff;
          text-decoration: none;
          display: block;
        }
      }
    }
  }

  .upload {
    float: right;
    margin-left: 20px;
    position: relative;
    padding-right: 15px;
    cursor: pointer;

    .icon {
      width: 45px;
      height: 45px;
      background: url("/img/upload.svg") no-repeat center;
      background-size: 30px;
      float: left;
    }
    .alert {
      float: right;
      background: #d42525;
      color: #fff;
      border-radius: 100%;
      width: 25px;
      height: 25px;
      padding: 0;
      line-height: 25px;
      font-family: Speedee-Bold;
      position: absolute;
      right: 0;
      bottom: 0;
    }
  }
}

.separator {
  width: 100%;
  height: 60px;
}
</style>
